import {Button, ButtonGroup, closeCurrentDialog, TextInput} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useState} from 'react';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

export interface SectionRenameDialogProps extends TestIdProps {
  name: string;
  onRename: (name: string) => void;
  confirmLabel?: string;
}

export function SectionRenameDialog(props: SectionRenameDialogProps) {
  const [draft, setDraft] = useState<string | null>(props.name);

  const trimmed = (draft ?? '').trim();

  const handleConfirm = () => {
    if (trimmed.length > 0) {
      props.onRename(trimmed);
    }
    closeCurrentDialog();
  };

  return (
    <VStack spacing={4}>
      <TextInput
        value={draft}
        onChange={setDraft}
        maxLength={255}
        placeholder={i18n.t('entity.recordAudit.checklist.sectionName')}
        data-testid={suffixTestId('sectionRenameInput', props)}
      />
      <ButtonGroup align="right">
        <Button
          variant="secondary"
          title={i18n.t('general.actions.cancel')}
          onClick={closeCurrentDialog}
          data-testid={suffixTestId('sectionRenameCancel', props)}
        />
        <Button
          title={props.confirmLabel ?? i18n.t('general.actions.rename')}
          isDisabled={trimmed.length === 0}
          onClick={handleConfirm}
          data-testid={suffixTestId('sectionRenameConfirm', props)}
        />
      </ButtonGroup>
    </VStack>
  );
}
